export default {
    configHeadData: [
        {
            title: "纳税人名称",
            prop: "companyName",
            width: "150",
        },
        {
            title: "公司代码",
            prop: "companyCode",
            width: "150",
        },
        {
            title: "所属期",
            prop: "period",
            width: "150"
        },
        {
            title: "事项名称",
            prop: "projectBoard",
            width: "150",
        },
        {
            title: "申报期限",
            prop: "sbqx",
            width: "150",
        },
        {
            title: "缴款期限",
            prop: "jkqx",
            width: "150",
        },
        {
            title: "申报周期",
            prop: "cycleId",
            width: "150",
            custom: true
        },
        {
            title: "漏报提示",
            prop: "message",
            width: "150",
        },
        {
            title: "税局本期应补退税额总额",
            prop: "bqybtseSj",
            width: "150",
        },
        {
            title: "申报状态",
            prop: "state",
            width: "150",
            custom: true
        },
        {
            title: "缴款状态",
            prop: "payState",
            width: "150",
            custom: true
        },
    ],
    tablePagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey: 0
    },
    searchlist: [
        {
            prop: 'companyName',
            label: '纳税人名称',
            type: 'input',
        },
        {
            prop: 'companyCode',
            label: '公司代码',
            type: 'input',
        },
        {
            prop: 'period',
            label: '所属期',
            type: "datemonth",
            valueformat: 'yyyyMM'
        },
        {
            prop: 'projectBoard',
            label: '事项名称',
            type: 'input',
        },
        {
            prop: 'state',
            label: '申报状态',
            type: 'select',
            selectval: [
                {
                    label: "未申报",
                    value: "0"
                },
                {
                    label: "已申报",
                    value: "1"
                },
            ]
        },
        {
            prop: 'payState',
            label: '缴款状态',
            type: 'select',
            selectval: [
                {
                    label: "无需缴款",
                    value: "-1"
                },
                {
                    label: "未缴款",
                    value: "0"
                },
                {
                    label: "已缴款",
                    value: "1"
                },
            ]
        },
        {
            prop: 'sbqx',
            label: '申报期限',
            valueformat: 'yyyy-MM-dd',
            type: 'date',
        },
        {
            prop: 'jkqx',
            label: '缴款期限',
            valueformat: 'yyyy-MM-dd',
            type: 'date',
        },
    ],
    searchdata: {
        companyName: '',
        companyCode: "",
        period: "",
        projectBoard: '',
        state: "",
        payState: "",
        sbqx: [],
        jkqx: [],
    }
}
